export const routes = {
  tmcallback: "/[teamSchema]/tmcallback",
  landing: "/[teamSchema]/landing",
  home: "/[teamSchema]/home",
  checkout: "/[teamSchema]/checkout",
  auth: "/[teamSchema]/auth",
  my_rewards: "/[teamSchema]/my_rewards",
  my_group: "/[teamSchema]/my_group",
  group_invite: "/[teamSchema]/group_invite",
  purchase_history: "/[teamSchema]/purchase_history",
  manage_subscription: "/[teamSchema]/manage_subscription",
  terms_and_condition: "/[teamSchema]/terms_and_condition",
  privacy_policy: "/[teamSchema]/privacy_policy",
  faqs: "/[teamSchema]/faqs",
  how_points_work: "/[teamSchema]/how_points_work",
  addons_success_purchase: "/[teamSchema]/addons_success_purchase",
  marketplace_events: "/[teamSchema]/marketplace_events",
  marketplace_create_listing: "/[teamSchema]/marketplace_create_listing",
  marketplace_home: "/[teamSchema]/marketplace_home",
  marketplace_listing: "/[teamSchema]/marketplace_listing",
  marketplace_thank_you: "/[teamSchema]/marketplace_thank_you",
  offers: "/[teamSchema]/offers",
  offerId: "/[teamSchema]/offers/[offerId]",
  upgrades: "/[teamSchema]/upgrades",
  gift: "/[teamSchema]/gift",
  redeem_gift: "/[teamSchema]/redeem_gift",
} as const;
